<!--
 * @Author: fengzhongmei
 * @Date: 2020-05-20 15:23:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-01 11:13:38
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <Modal v-model="modal"
           :title="$t('设置到期时间')"
           width="600"
           :mask-closable="false"
           @on-cancel="cancel">
        <div class="days">
            {{$t("当前统一设置到期时间为")}},<b>{{$t('每月')}}{{formData.timeData}}{{$t('号')}} 23:59:59</b>
        </div>
        <Form ref="instanceForm"
              :model="formData"
              :rules="rules"
              :label-colon="true"
              :hide-required-mark="true"
              label-position="right"
              :label-width="100">
            <FormItem :label="$t('调整到期日期')">
                <!-- 实例规格 -->
                <Select style="width:120px;"
                        :placeholder="$t('到期日期')"
                        v-model="formData.timeData">
                    <Option v-for="(item, index) in timeDataList"
                            :key="index"
                            :value="item.value">{{item.name}}</Option>
                </Select>&nbsp;&nbsp;23:59:59
            </FormItem>
            <p class="explanation">
                {{$t('调整完到期日之后不会更改现有资源到期时间，您可在资源续费时重新调整对齐到期时间。')}}
            </p>
        </Form>
        <div slot="footer">
            <Button @click="cancel"
                    type="text">{{$t('取消')}}</Button>
            <Button :loading="loading"
                    @click="submit"
                    type="primary">{{loading ? $t('保存中') : $t('保存')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api.js'
export default {
    name: 'expirationtime',
    data () {
        return {
            modal: false,
            loading: false,
            formData: {
                timeData: 1
            },
            timeDataList: [],
            rules: {}
        }
    },
    created () {
        this.getTimeData()
    },
    methods: {
        // 打开设置时间弹窗
        open (data) {
            this.modal = true
            if (data) {
                this.formData.timeData = data
            } else {
                this.getUnifyDate()
            }
        },
        // 获取时间下拉
        getTimeData () {
            this.timeDataList = []
            for (let i = 1; i <= 28; i++) {
                this.timeDataList.push({ value: i, name: (this.$t('每月') + i + this.$t('号')) })
            }
        },
        // 获取设置统一的时间
        getUnifyDate () {
            this.axios.get(
                this.urlFormat(API.RENEW_UNIFY_DATE, false))
                .then(res => {
                    this.formData.timeData = res.unifyDate
                }).catch(e => {
                    console.log(e)
                })
        },
        // 提交
        submit () {
            this.loading = true
            this.axios.put(
                this.urlFormat(API.RENEW_UNIFY_DATE, false),
                {
                    unifyDate: this.formData.timeData
                }
            ).then(res => {
                this.loading = false
                if (res) {
                    // 刷新页面，传递数据
                    this.$emit('refresh', this.formData.timeData)
                    this.cancel()
                }
            }).catch(e => {
                this.loading = false
            })
        },
        // 清空数据
        cancel () {
            this.modal = false
            this.formData.timeData = 1
        }
    }
}
</script>
<style lang="less" scoped>
.days {
    font-size: 13px;
    padding: 10px 15px;
    background: #f5f6f7;
    margin: 0px 0px 15px 0px;
    b {
        font-size: 12px;
        font-weight: 600;
        padding: 0 5px;
        vertical-align: middle;
        color: #ff2a00;
    }
}
.explanation {
    font-size: 12px;
    color: #999;
    padding: 0 0 15px 15px;
    margin: -10px 0 0 0;
}
</style>
